// extracted by mini-css-extract-plugin
module.exports = {"app":"_3sz-Jorbvi2LDO38TpQcMl","brand":"_u4avc-WstuZP5sdbqIV1","content":"_1xM1AikmVov8veARQ3yrpP","appContent":"gsYlqHuubB3bKiaXdybMG","notifs":"_1eUBVP7cLg7TK6BWz4jC8l"};